
  export default {
    mounted() {
      this.chartData = JSON.parse(this.el.dataset.chartData || "[]")
      this.i18n = JSON.parse(this.el.dataset.i18n || "null") || window.I18n || {}
      this.smoothingMode = '7day'
      this.renderChart()

      // Listen for button clicks on the toggle
      const toggleContainer = document.getElementById('attendance-trend-smoothing')
      if (toggleContainer) {
        toggleContainer.addEventListener('click', (e) => {
          const btn = e.target.closest('.smoothing-btn')
          if (!btn) return

          // Update active state
          toggleContainer.querySelectorAll('.smoothing-btn').forEach(b => {
            b.classList.remove('bg-white', 'text-text-primary', 'font-semibold', 'shadow-[0px_2px_8px_0px_rgba(14,8,84,0.12)]')
            b.classList.add('text-text-secondary', 'font-normal')
          })
          btn.classList.remove('text-text-secondary', 'font-normal')
          btn.classList.add('bg-white', 'text-text-primary', 'font-semibold', 'shadow-[0px_2px_8px_0px_rgba(14,8,84,0.12)]')

          this.smoothingMode = btn.dataset.value
          this.renderChart()
        })
      }
    },

    calculateMovingAverage(data, windowSize) {
      return data.map((_, index, arr) => {
        const start = Math.max(0, index - windowSize + 1)
        const window = arr.slice(start, index + 1)
        const sum = window.reduce((acc, val) => acc + val, 0)
        return Math.round(sum / window.length)
      })
    },

    renderChart() {
      const chartData = this.chartData
      const i18n = this.i18n
      const t = (key) => i18n[key]
      if (chartData.length === 0) {
        this.el.innerHTML = `<div class="flex items-center justify-center h-full text-text-muted">${t("No attendance data available")}</div>`
        return
      }

      import("highcharts").then((Highcharts) => {
        const dates = chartData.map(d => d.date)
        const rawBadgeIns = chartData.map(d => d.badge_ins)

        let displayData, seriesName, tooltipLabel
        switch (this.smoothingMode) {
          case 'daily':
            displayData = rawBadgeIns
            seriesName = t("Daily")
            tooltipLabel = t("Daily")
            break
          case '28day':
            displayData = this.calculateMovingAverage(rawBadgeIns, 28)
            seriesName = t("28-day Average")
            tooltipLabel = t("28-day avg")
            break
          case '7day':
          default:
            displayData = this.calculateMovingAverage(rawBadgeIns, 7)
            seriesName = t("7-day Average")
            tooltipLabel = t("7-day avg")
            break
        }

        const isSmoothed = this.smoothingMode !== 'daily'

        window.Enaia.applyHighchartsTheme(Highcharts.default)
        Highcharts.default.chart(this.el.id, {
          chart: {
            type: 'area',
            backgroundColor: 'transparent'
          },
          title: { text: null },
          xAxis: {
            categories: dates,
            labels: {
              rotation: -45,
              style: {
                fontSize: '10px',
                color: '#6B7280'
              },
              step: Math.ceil(dates.length / 10)
            }
          },
          yAxis: {
            min: 0,
            title: {
              text: t("Badge-ins"),
              style: { fontSize: '12px' }
            }
          },
          legend: { enabled: false },
          tooltip: {
            useHTML: true,
            formatter: function() {
              const rawValue = rawBadgeIns[this.point.index]
              if (isSmoothed) {
                return `<div style="padding: 8px;">
                  <strong>${this.x}</strong><br/>
                  ${tooltipLabel}: ${this.y}<br/>
                  ${t("Daily")}: ${rawValue}
                </div>`
              } else {
                return `<div style="padding: 8px;">
                  <strong>${this.x}</strong><br/>
                  ${t("Badge-ins")}: ${this.y}
                </div>`
              }
            }
          },
          plotOptions: {
            area: {
              fillColor: {
                linearGradient: { x1: 0, y1: 0, x2: 0, y2: 1 },
                stops: [
                  [0, 'rgba(20, 184, 166, 0.3)'],
                  [1, 'rgba(20, 184, 166, 0.05)']
                ]
              },
              lineColor: '#0086e6',
              lineWidth: 2,
              marker: {
                enabled: false
              }
            }
          },
          series: [{
            name: seriesName,
            data: displayData,
            color: '#0086e6'
          }],
          credits: { enabled: false }
        })
      })
    }
  }
